import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { auth, firestore } from '../../firebase/firebase';

export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

interface LoginSuccessAction {
  type: typeof LOGIN_SUCCESS;
  payload: {
    user: {
      email: string | undefined | null;
      uuid: string | undefined | null;
      role: string | undefined | null;
    };
  };
}

interface LoginLoadingAction {
  type: typeof LOGIN_LOADING;
}

interface LoginFailureAction {
  type: typeof LOGIN_FAILURE;
  payload: {
    error: string;
  };
}

interface LogoutAction {
  type: typeof LOGOUT;
}

export type AuthActionTypes =
  | LoginSuccessAction
  | LogoutAction
  | LoginLoadingAction
  | LoginFailureAction;

const loginLoading = (): LoginLoadingAction => {
  return { type: LOGIN_LOADING };
};

export const loginSuccess = (
  email: string | undefined | null,
  uuid: string | undefined | null,
  role: string | undefined | null
): LoginSuccessAction => {
  return {
    type: LOGIN_SUCCESS,
    payload: {
      user: {
        email,
        uuid,
        role,
      },
    },
  };
};

const loginFailure = (message: string): LoginFailureAction => {
  return { type: LOGIN_FAILURE, payload: { error: message } };
};

const logoutAction = (): LogoutAction => {
  return { type: LOGOUT };
};

export const login = (email: string, password: string) => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    dispatch(loginLoading());

    try {
      const userCredential = await auth.signInWithEmailAndPassword(
        email,
        password
      );
    } catch (error) {
      dispatch(loginFailure(error.message));
    }

    // const userDoc = await firestore
    //   .collection('users')
    //   .doc(userCredential.user?.uid)
    //   .get();

    // if (userDoc.exists) {
    //   const role = userDoc.data()?.role;
    //   if (role === 'admin') {
    //     dispatch(
    //       loginSuccess(
    //         userCredential.user?.email,
    //         userCredential.user?.uid,
    //         role
    //       )
    //     );
    //   } else {
    //     dispatch(loginFailure('Not record found'));
    //   }
    // } else {
    //   dispatch(loginFailure('Not record found'));
    // }
  };
};

export const relogin = (email: string, uid: string) => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    const userDoc = await firestore.collection('users').doc(uid).get();

    if (userDoc.exists) {
      const role = userDoc.data()?.role;
      const email = userDoc.data()?.email;

      if (role === 'admin') {
        dispatch(loginSuccess(email, uid, role));
      } else {
        dispatch(logout());
        dispatch(loginFailure('Permission Denied'));
      }
    } else {
      dispatch(logout());
    }
  };
};

export const logout = () => {
  return (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    auth
      .signOut()
      .then(() => dispatch(logoutAction()))
      .catch((error) => console.log('[logout]', error));
  };
};
